import { AxiosError } from 'axios';
import { createAsyncAction } from 'typesafe-actions';

import { VendorPegbordAPIItem } from './vendorPegboard.types';

export const vendorPegboardActions = {
  getVendorPegboards: createAsyncAction(
    'api/GET_VENDOR_PEGBOARDS_REQUEST',
    'api/GET_VENDOR_PEGBOARDS_SUCCESS',
    'api/GET_VENDOR_PEGBOARDS_FAILURE'
  )<void, {
    [key: string]: Array<VendorPegbordAPIItem>
  }, AxiosError>(),
};
